var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"max-width-chip",attrs:{"small":"","color":_vm.status_ja[_vm.status].color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.status_ja[_vm.status].label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }